// extracted by mini-css-extract-plugin
export default {"container":"jC-z","dimension":"kC-z","dimensionLabels":"lC-z"};